import { IValidationRule } from "@/types"

const orderTypeValidationRules: { [s: string]: IValidationRule } = {
    purposeId: {
        required: true,
    },
    invoiceCode: {
        required: true,
    },
    invoiceCodeDescription: {
        required: true,
    },
    creditNoteCode: {
        required: true,
    },
    creditNoteCodeDescription: {
        required: true,
    },
}

export default orderTypeValidationRules
